'use client';
import Security from './_components';

const Content = () => {
  return <Security />;
};

export default Content;
